import 'vuetify/styles'; // 1. Pull the official Vuetify 3/4 core styles
import { createVuetify } from 'vuetify';

// 2. Define your design specifications
const monadLightTheme = {
  dark: false,
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    primary: '#2e8b57', // seagreen from your CSS variables
    error: '#cd0a0a',
    'surface-variant': '#f7f7f7', // matches your background-contrast
  },
};

const monadDarkTheme = {
  dark: true,
  colors: {
    background: '#222222',
    surface: '#222222',
    primary: '#2e8b57', // seagreen
    error: '#cf6679',
    'surface-variant': '#333333', // matches your dark background-contrast
  },
};

export default createVuetify({
  theme: {
    defaultTheme: 'monadLightTheme',
    themes: {
      monadLightTheme,
      monadDarkTheme,
    },
  },
});
